import ReactQuill from 'react-quill';
import {toSnakeCase} from '../../functions/camelSnakeCaseConversion';
const Quill = ReactQuill.Quill;

export const addVariables = () =>{
    let Embed = Quill.import('blots/embed');
    class Variable extends Embed {
        static create(variable) {
            let node = super.create();
            if(variable && variable[0] && variable[1]) {
                node.setAttribute('data-label', variable[0]);
                node.textContent = variable[1];
            } else {
                node.setAttribute('data-label', variable.label);
                node.textContent = variable.value;
            }
            return node;
        }
        static value(node) {
            return {label: node.getAttribute('data-label'), value: node.textContent};
        }
        static formats(domNode) {
            const formats = {};
            if(domNode.getAttribute('data-bold') === 'true' || domNode.closest('strong')) {
                formats.bold = true;
            }
            if(domNode.getAttribute('data-italic') === 'true' || domNode.closest('em')) {
                formats.italic = true;
            }
            return formats;
        }
        format(name, value) {
            if(name !== 'bold' && name !== 'italic') {
                return;
            }
            if(value) {
                this.domNode.setAttribute(`data-${name}`, 'true');
            } else {
                this.domNode.removeAttribute(`data-${name}`);
            }
        }
    }
    
    Variable.blotName = 'variable';
    Variable.tagName = 'span';
    Variable.className = 'variable';
    
    Quill.register(Variable);
};

export const addNoDelete = () =>{
    let BlockEmbed = Quill.import('blots/block/embed');
    class NoDelete extends BlockEmbed {
        static create(value) {
            let node = super.create();
            node.innerHTML = value;
            node.setAttribute('contenteditable', 'false');
            return node;
        }
    
        static value(node) {
            return node.innerHTML;
        }
        deleteAt(index, length) {
            console.log(index, length, 'can not delete');
        }
    }
    
    NoDelete.blotName = 'nodelete';
    NoDelete.tagName = 'p';
    NoDelete.className = 'no-delete';
    
    Quill.register(NoDelete);
};

export const replaceVariablesInDelta = (delta) => {
    return delta.ops.map((op) => {
        if(op.insert?.nodelete) {
            const tempDiv = document.createElement('div');
            tempDiv.innerHTML = op.insert.nodelete;
            let newTextContent = tempDiv.textContent || '';
            const spans = tempDiv.querySelectorAll('span[data-label]');
            spans.forEach(span => {
                const variableName = span.getAttribute('data-label');
                const snakeCaseVariableName = toSnakeCase(variableName);
                newTextContent = newTextContent.replace(span.textContent, `[${snakeCaseVariableName}]`);
            });
            return {insert: {nodelete: newTextContent}};
        }
        else if(op.insert?.variable) {
            const variable = toSnakeCase(op.insert.variable.label);
            const attributes = {};
            if(op.attributes?.bold) {
                attributes.bold = true;
            }
            if(op.attributes?.italic) {
                attributes.italic = true;
            }
            return Object.keys(attributes).length > 0
                ? {insert: `[${variable}]`, attributes}
                : {insert: `[${variable}]`};
        }
        return op;
    });
};

export const deltaToHtml = (delta) => {
    const container = document.createElement('div');
    document.body.appendChild(container);        
    let quill = new Quill(container, {
        theme: 'snow'
    });
    quill.setContents(delta);
    let html = container.querySelector('.ql-editor').innerHTML;
    html = html.replace(/<p><\/p>/g, '<p><br></p>');
    document.body.removeChild(container);
    return html;
};

export const convertVariablesToHtml = (text, variables, t) => {
    let processedText = convertVariablesToHtmlInline(text, variables, t, false);
    const parts = processedText.split(/\n\n/);
    processedText = parts.map(part => {
        const lines = part.split(/\n/);
        return lines.map(line => `<p>${line}</p>`).join('');
    }).join('<p><br></p>');
    return processedText;
};

export const convertVariablesToHtmlInline = (text, variables, t, makeNonEditable = true) => {
    if(typeof text !== 'string') return '';
    return text.replace(/\[([^\]]+)\]/g, (match, label) => {
        const variableKey = Object.keys(variables).find(key => toSnakeCase(key) === label);
        const editableAttr = makeNonEditable ? ' contenteditable="false"' : '';
        return variableKey
            ? `<span class="variable"${editableAttr} data-label="${variableKey}">${variables[variableKey] || t(variableKey)}</span>`
            : match;
    });
};

/** Plain-text preview: replaces [snake_case] placeholders with sample values from variables map */
export const replaceBracketPlaceholdersWithValues = (plainText, variables = {}, t) => {
    if(typeof plainText !== 'string' || !plainText) return '';

    const labelToVariableKey = Object.keys(variables).reduce((acc, key) => {
        acc[toSnakeCase(key)] = key;
        return acc;
    }, {});

    return plainText.replace(/\[([^\]]+)\]/g, (match, label) => {
        const variableKey = labelToVariableKey[label];
        if(!variableKey) return match;
        const resolved = variables[variableKey] ?? (typeof t === 'function' ? t(variableKey) : undefined);
        return resolved === undefined || resolved === null ? match : String(resolved);
    });
};
